import { Apple, Play } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AppStoreButtonsProps {
  size?: "default" | "lg";
  className?: string;
}

export default function AppStoreButtons({ size = "default", className = "" }: AppStoreButtonsProps) {
  const isLarge = size === "lg";

  return (
    <div className={`flex flex-col sm:flex-row gap-4 ${className}`}>
      <a
        href="https://apps.apple.com"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block"
      >
        <Button
          size={isLarge ? "lg" : "default"}
          variant="default"
          className={`${isLarge ? "px-8 py-6 text-base" : "px-6 py-5"} w-full sm:w-auto bg-black hover:bg-gray-800 text-white`}
        >
          <Apple className={`${isLarge ? "w-6 h-6" : "w-5 h-5"} mr-2`} />
          <div className="flex flex-col items-start">
            <span className="text-xs">Download on the</span>
            <span className={`${isLarge ? "text-base" : "text-sm"} font-semibold`}>App Store</span>
          </div>
        </Button>
      </a>

      <a
        href="https://play.google.com"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block"
      >
        <Button
          size={isLarge ? "lg" : "default"}
          variant="default"
          className={`${isLarge ? "px-8 py-6 text-base" : "px-6 py-5"} w-full sm:w-auto bg-black hover:bg-gray-800 text-white`}
        >
          <Play className={`${isLarge ? "w-6 h-6" : "w-5 h-5"} mr-2`} />
          <div className="flex flex-col items-start">
            <span className="text-xs">Get it on</span>
            <span className={`${isLarge ? "text-base" : "text-sm"} font-semibold`}>Google Play</span>
          </div>
        </Button>
      </a>
    </div>
  );
}

